export default __webpack_public_path__ + "locales/ja-JP/Common.json?hash=fd8cfe03314cace30801a5572ba6d8ec";